import React, { Fragment, Suspense, useEffect, useState } from "react";
import Preloader from "./elements/Preloader";
import { Link } from "react-router-dom";

const ErrorPage = () => {
 

  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
        <div style={styles.container}>
            <h1 style={styles.title}>404</h1>
            <p style={styles.message}>Oops! The page you are looking for does not exist.</p>
            <Link to="/" style={styles.link}>Go back to Home</Link>
            </div>
        </Suspense>
      </Fragment>
    </>
  );
};
const styles = {
    container: {
      textAlign: 'center',
      padding: '100px',
    },
    title: {
      fontSize: '100px',
      marginBottom: '20px',
    },
    message: {
      fontSize: '24px',
      marginBottom: '40px',
    },
    link: {
      fontSize: '18px',
      color: '#007bff',
      textDecoration: 'none',
    },
  };
export default ErrorPage;
